import raw from "../data/resume.yaml";
import type { ResumeData } from "../types";

export const data: ResumeData = raw;
export default data;
